<style scoped lang="scss" type="text/scss">
    .competition-manage-container {
        .search-bar {
            .selector {
                width: 8rem;
            }
        }

        .competition-items {
            display: flex;
            flex-wrap: wrap;
            margin: 0 0 0 -1rem;

            .competition-item {
                width: calc(25% - 1rem);
                height: 17rem;
                margin: 1rem 0 0 1rem;
            }
        }
    }

    @media screen and (min-width: 100rem) {
        .competition-item {
            width: calc(20% - 1rem) !important;
        }
    }
</style>

<template>
    <div class="competition-manage-container">
        <el-input class="search-bar full-width" placeholder="请输入赛事名称，按回车搜索" v-model="keyword" clearable
                  @keypress.native.enter="searchCompetition"
        >
        </el-input>

        <div class="competition-items global-relative">
            <add-block class="competition-item" title="赛事" @click.native="showEditor"></add-block>
            <competition-item class="competition-item actual"
                              v-for="(competition, index) in competitions" :key="index"
                              :info="competition"
                              @call-remove="remove(competition.id, ...arguments)"
                              @call-edit="showUpdateEditor(competition.id, ...arguments)"
            >
            </competition-item>
        </div>

        <pagination :page-size="pageSize" :current-page.sync="currentPage" :total="total"
                    @current-change="searchCompetition">
        </pagination>

        <popup :visible.sync="isEditorVisible"
               :deletable="isUpdateMode"
               :is-update="isUpdateMode"
               :id="updateId"
               @need-reload="searchCompetition"
        >
        </popup>
    </div>
</template>

<script>
    import AddBlock from '../../../../components/add-block/index';
    import CompetitionItem from './competition-item';
    import Popup from './popup';
    import {updatePageOption} from '../../../../utils/page';
    import {handleCompetitions} from '../../../../utils/data-handler';

    export default {
        name: '',
        components: {
            AddBlock,
            CompetitionItem,
            Popup
        },
        computed: {
            page () {
                return {
                    page_size: this.pageSize,
                    page_num: this.currentPage
                };
            }
        },
        created () {
            this.searchCompetition();
        },
        data () {
            return {
                competitions: [],
                keyword: '',
                isEditorVisible: false,
                isUpdateMode: false,
                updateId: null,
                pageSize: 19,
                total: 0,
                currentPage: 1
            };
        },
        methods: {
            showEditor () {
                this.isEditorVisible = true;
                this.isUpdateMode = false;
                this.updateId = null;
            },
            showUpdateEditor (id, callback) {
                this.isEditorVisible = true;
                this.isUpdateMode = true;
                this.updateId = id;
                callback();
            },
            searchCompetition () {
                return this.$store.dispatch('competition/searchByFuzzyNameWithPagination', {
                    name: this.keyword,
                    ...this.page
                }).then(response => {
                    const data = response.data;
                    updatePageOption(this, data);
                    this.competitions = handleCompetitions(data.list);
                });
            },
            loadMainCompetitions () {
                this.$store.dispatch('competition/loadMainCompetitions').then();
            },
            remove (id, callback) {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('competition/deleteCompetition', {id}, '删除成功').then(_ => {
                        Promise.all([
                            this.searchCompetition(), this.loadMainCompetitions()
                        ]).then(_ => {
                            callback();
                        });
                    }).catch(_ => {
                        callback();
                    });
                }).catch(_ => {
                    callback();
                });
            }
        }
    };
</script>
